import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {PlayerEventInfo} from "../models/playerEventInfo";
import {Player} from '../models/player';
import {map} from "rxjs/operators";
import {PlayerService} from "./player.service";

@Injectable()
export class PlayerEventInfoService {

  private apiUrl: string = environment.API_BASE_URL + '/playereventinfo';

  constructor(private authHttp: HttpClient) {
  }

  private static getRequestOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  public create(body: PlayerEventInfo, currentPlayer: Player): Observable<PlayerEventInfo> {
    body.statusModifiedByPlayerId = currentPlayer.id;
    body.statusModifiedByPlayerEmail = currentPlayer.email;

    let bodyString = JSON.stringify(body);
    return this.authHttp.post<PlayerEventInfo>(`${this.apiUrl}`, bodyString, PlayerEventInfoService.getRequestOptions()).pipe(
      map((playerEventInfo) => this.normalizePlayerEventInfo(playerEventInfo))
    );
  }

  public fetchForEvent(eventId: string): Observable<PlayerEventInfo[]> {
    return this.authHttp.get<PlayerEventInfo[]>(`${this.apiUrl}/event/${eventId}`, PlayerEventInfoService.getRequestOptions()).pipe(
      map((playerEventInfos) => (playerEventInfos || []).map((playerEventInfo) => this.normalizePlayerEventInfo(playerEventInfo)))
    );
  }

  public update(body: PlayerEventInfo, currentPlayer: Player): Observable<PlayerEventInfo> {
    body.statusModifiedByPlayerId = currentPlayer.id;
    body.statusModifiedByPlayerEmail = currentPlayer.email;

    let bodyString = JSON.stringify(body);
    return this.authHttp.put<PlayerEventInfo>(`${this.apiUrl}/${body['id']}`, bodyString, PlayerEventInfoService.getRequestOptions()).pipe(
      map((playerEventInfo) => this.normalizePlayerEventInfo(playerEventInfo))
    );
  }

  public getPlayerEventInfo(id: string): Observable<PlayerEventInfo> {
    return this.authHttp.get<PlayerEventInfo>(`${this.apiUrl}/${id}`).pipe(
      map((playerEventInfo) => this.normalizePlayerEventInfo(playerEventInfo))
    );
  }

  public delete(id: string): Observable<PlayerEventInfo> {
    return this.authHttp.delete<PlayerEventInfo>(`${this.apiUrl}/${id}`).pipe(
      map((playerEventInfo) => this.normalizePlayerEventInfo(playerEventInfo))
    );
  }

  private normalizePlayerEventInfo(playerEventInfo: PlayerEventInfo): PlayerEventInfo {
    if (playerEventInfo) {
      PlayerService.normalizePlayerAvatar(playerEventInfo.player);
    }
    return playerEventInfo;
  }
}
